import { faClipboard } from "@fortawesome/free-regular-svg-icons";
import { faCheck, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { trackEvent } from "../../amplify/api-gateway/user-events";

interface CopyToClipboardButtonProps {
    user: any;
    onClick: () => void;
    defaultIcon?: IconDefinition;
    customStyling?: string;
    overlayTriggerMessage?: string;
    module?: string;
}

const CopyToClipboardButton = ({
    user,
    onClick,
    defaultIcon,
    customStyling,
    overlayTriggerMessage,
    module,
}: CopyToClipboardButtonProps) => {
    const [submitted, setSubmitted] = useState(false);

    const handleClick = () => {
        onClick();

        // Show checkmark
        setSubmitted(true);

        // Revert back after 1 second
        setTimeout(() => {
            setSubmitted(false);
        }, 1000);

        if (module) {
            trackEvent(`copy_to_clipboard?module=${module}`, user?.username, { module: module });
        }
    };

    const getButton = () => {
        return (
            <Button variant="link" className={customStyling ?? `assistant-feedback-btn me-1`} onClick={handleClick}>
                {/* @ts-ignore */}
                <FontAwesomeIcon icon={submitted ? faCheck : defaultIcon ?? faClipboard} />
            </Button>
        );
    }

    if (overlayTriggerMessage) {
        return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        {overlayTriggerMessage}
                    </Tooltip>
                }
            >
                {getButton()}
            </OverlayTrigger>
        )
    }

    return getButton();
};

export default CopyToClipboardButton;
